import React from 'react';
import { Trash2 } from 'lucide-react';

import { IMAGE_RESOURCES } from './ImageBlockLayer';

// Type-specific panel for a selected image block. Position/size live in
// the generic PositionPanel/SizePanel — there's nothing else to configure
// yet (see blocks/image-block.md), so this panel exists only to satisfy
// the Block capability contract's trash-icon delete affordance (the
// counterpart to the generic keyboard Delete/Backspace shortcut), the same
// pattern TextPropertiesPanel uses. Title reflects which fixed resource
// this particular block was created with (logo vs. slogan).
export default function ImagePropertiesPanel({ block, onDelete }) {
  if (!block) return null;

  const label = block.resourceKey === IMAGE_RESOURCES.DEFAULT_SLOGAN ? 'Slogan' : 'Logo';

  return (
    <div className="ss-print__panel">
      <div className="ss-print__panel-header">
        <h3 className="ss-print__panel-title">{label} Properties</h3>
        <div className="ss-print__panel-header-actions">
          <button
            type="button"
            className="ss-print__lock-toggle ss-print__lock-toggle--danger"
            onClick={onDelete}
            aria-label={`Delete this ${label.toLowerCase()} block`}
            title="Delete"
          >
            <Trash2 size={16} aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
